import { useEffect, useState } from 'react';
import type { ITextCommitProps } from './ITextCommitProps';

/**
 * Текстове поле конструктора: редагується локально, зберігається, коли поле втрачає фокус або натиснуто Enter (лише змінене значення);
 * Escape повертає збережене. Нове значення ззовні (відповідь сервера) замінює чернетку.
 */
export function TextCommit({ value, onCommit, label, className, placeholder, title, disabled }: ITextCommitProps) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const commit = () => { if (draft !== value) onCommit(draft); };
  return (
    <input className={className} value={draft} aria-label={label} placeholder={placeholder} title={title} disabled={disabled}
      onChange={(e) => setDraft(e.target.value)} onBlur={commit}
      onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') setDraft(value); }} />
  );
}
